// import React from 'react'
// import { useEffect, useRef, useState } from 'react';
// import styles from './styles.module.scss'

// import Lenis from '@studio-freight/lenis'
// import { useTransform, useScroll, motion } from 'framer-motion';
// import Rounded from '../../Projects/Test/common/RoundedButton';
// import Home from '../../animations/page';

// import { ArrowRight } from 'lucide-react';




// const images = [
//     "7.jpg",
//     "2.jpg",
//     "3.jpg",
//     "4.jpg",
//     "5.jpg",
//     "6.jpg",
//     "7.jpg",
//     "8.jpg",
//     "9.jpg",
//     "10.jpg",
//     "11.jpg",
//     "12.jpg",
//   ]
  



// function Paralax() {
//     const gallery = useRef(null);
//     const [dimension, setDimension] = useState({ width: 0, height: 0 });
  
//     const { scrollYProgress } = useScroll({
//       target: gallery,
//       offset: ['start end', 'end start']
//     });
  
//     const { height } = dimension;
//     const y = useTransform(scrollYProgress, [0, 1], [0, height * 2]);
//     const y2 = useTransform(scrollYProgress, [0, 1], [0, height * 3.3]);
//     const y3 = useTransform(scrollYProgress, [0, 1], [0, height * 1.25]);
//     const y4 = useTransform(scrollYProgress, [0, 1], [0, height * 3]);
  
//     useEffect(() => {
//       const lenis = new Lenis();
  
//       const raf = (time) => {
//         lenis.raf(time);
//         requestAnimationFrame(raf);
//       };
  
//       const resize = () => {
//         setDimension({ width: window.innerWidth, height: window.innerHeight });
//       };
  
//       window.addEventListener("resize", resize);
//       requestAnimationFrame(raf);
//       resize();
  
//       return () => {
//         window.removeEventListener("resize", resize);
//       };
//     }, []);


// // circle text 

// const [rotatedText, setRotatedText] = useState('');

// useEffect(() => {
//   const originalText = "Devshakilh - from  - Bangladesh -";
//   const chars = originalText.split("");
//   const rotatedChars = chars.map((char, i) => (
//     <span key={i} style={{ transform: `rotate(${i * 10.3}deg)` }}>{char}</span>
//   ));
//   setRotatedText(rotatedChars);
// }, []);


  
//     return (
//       <main className={`${styles.main} my-12`}>
//         <div data-aos="fade-up"
//      data-aos-duration="5000" className={`${styles.bg}  h-screen fle md:mt-20  mdflex-row md:justify-between  justify-center gap-10 items-center   lg:p-12 bg-[#FFFFFF]`} >
//     <div className="mdw-1/2  lgw-1/2 w-full text-center  md:text-start mb-6" data-aos="fade-down" >
//         <h1 className="lg:text-[120px]  sm:text-[120px]  text-white font-bold txt uppercase" >
//             {/* Md Shakil  <span className="text-secondary">Hossain</span>{" "} */}
//             <Home/>
//             <motion.div

// />
//         </h1>
        
//         <p className='font=Oswald  gap-2 py-10 text-center items-center justify-center  lg:hidden  m- md:m-0 text-3xl mt-2 font-bold lg:text-4xl ]  text- h_text '>I'm
// a
// freelance
// design
// &
// <br />
// developer✹

//         </p>
//         <p className='font=Oswald  gap-2 py-10  hidden  lg:block   m- md:m-0 text-2xl mt-2 font-bold lg:text-4xl ]  text- h_text '>I'm
// a
// freelance
// design
// &
// ✹
// developer

//         </p>




//         <button className=" lg:mt-12 mt-10 mb-12">
//             <a
//                 href="mailto:mdshakil6565a@gmail.com"
//                 target="_blank"
//                 rel="noreferrer"
//             >
              
// <Rounded>
//   <p className="text-white text-xl flex items-center justify-center gap-2 font-bold cursor-pointer">HIRE ME <span className='font-extrabold mt-[6px]' style={{ transform: 'rotate(-45deg)' }}>
//   <ArrowRight />
// </span>
// </p>
// </Rounded>
//             </a>
//         </button>
        
//     </div>

  
// <div className={`${styles.circle} `}>
//       <div className={styles.logo}></div>
//       <div className={styles.text}>
        
//         {rotatedText}
      
//       </div>

// </div>

// </div>
//         <div ref={gallery} className={styles.gallery}>
//           <Column images={[images[0], images[1], images[2]]} y={y} />
//           <Column images={[images[3], images[4], images[5]]} y={y2} />
//           <Column images={[images[6], images[7], images[8]]} y={y3} />
//           <Column images={[images[9], images[10], images[11]]} y={y4} />
//         </div>
//         <div className={styles.spacer}></div>
//       </main>
//     );
//   }
  
//   const Column = ({ images, y }) => {
//     return (
//       <motion.div
//         className={styles.column}
//         style={{ y }}
//       >
//         {
//           images.map((src, i) => {
//             return (
//               <div key={i} className={styles.imageContainer}>
//                 <img
//                   src={`/images/${src}`}
//                   alt='photos'
//                   fill
//                 />
//               </div>
//             );
//           })
//         }
//       </motion.div>
//     );
// }

// export default Paralax



import React, { useEffect, useState, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Lenis from '@studio-freight/lenis';
import { ArrowRight } from 'lucide-react';
import Rounded from '../../Projects/Test/common/RoundedButton';
import Home from '../../animations/page';
import styles from './styles.module.scss';

const images = [
  "7.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg", "8.jpg", "9.jpg", "10.jpg", "11.jpg", "12.jpg",
];

function Paralax() {
  const gallery = useRef(null);
  const [dimension, setDimension] = useState({ width: 0, height: 0 });
  const [loading, setLoading] = useState(true); // Loading state

  const { scrollYProgress } = useScroll({
    target: gallery,
    offset: ['start end', 'end start'],
  });

  const { height } = dimension;
  const y = useTransform(scrollYProgress, [0, 1], [0, height * 2]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, height * 3.3]);
  const y3 = useTransform(scrollYProgress, [0, 1], [0, height * 1.25]);
  const y4 = useTransform(scrollYProgress, [0, 1], [0, height * 3]);

  useEffect(() => {
    const lenis = new Lenis();
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    const resize = () => {
      setDimension({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", resize);
    requestAnimationFrame(raf);
    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const [rotatedText, setRotatedText] = useState('');

  useEffect(() => {
    const originalText = "Devshakilh - from  - Bangladesh -";
    const chars = originalText.split("");
    const rotatedChars = chars.map((char, i) => (
      <span key={i} style={{ transform: `rotate(${i * 10.3}deg)` }}>{char}</span>
    ));
    setRotatedText(rotatedChars);

    // Simulate loading complete by setting loading state to false after a delay
    setTimeout(() => {
      setLoading(false); // Animation starts after loading is complete
    }, 2000); // Adjust the time as needed
  }, []);

  return (
    <main className={`${styles.main} my-12`}>
      <div className={`${styles.bg} h-screen fle md:mt-20  mdflex-row md:justify-between justify-center gap-10 items-center lg:p-12 bg-[#FFFFFF]`}>
        <div className="mdw-1/2  lgw-1/2 w-full text-center  md:text-start mb-6" data-aos="fade-down">
          <h1 className="lg:text-[120px] sm:text-[120px] text-white font-bold txt uppercase">
            <Home />
            <motion.div />
          </h1>

          <p className='font=Oswald gap-2 py-10 text-center items-center justify-center lg:hidden m- md:m-0 text-3xl mt-2 font-bold lg:text-4xl'>
            I'm a freelance design & <br /> developer✹
          </p>
          <p className='font=Oswald gap-2 py-10 hidden lg:block m- md:m-0 text-2xl mt-2 font-bold lg:text-4xl'>
            I'm a freelance design & ✹ developer
          </p>

          <button className="lg:mt-12 mt-10 mb-12">
            <a href="mailto:mdshakil6565a@gmail.com" target="_blank" rel="noreferrer">
              <Rounded>
                <p className="text-white text-xl flex items-center justify-center gap-2 font-bold cursor-pointer">
                  HIRE ME
                  <span className='font-extrabold mt-[6px]' style={{ transform: 'rotate(-45deg)' }}>
                    <ArrowRight />
                  </span>
                </p>
              </Rounded>
            </a>
          </button>
        </div>

        <div className={`${styles.circle}`}>
          <div className={styles.logo}></div>
          <div className={styles.text}>
            {!loading && rotatedText} {/* Only show text when loading is complete */}
          </div>
        </div>
      </div>

      <div ref={gallery} className={styles.gallery}>
        <Column images={[images[0], images[1], images[2]]} y={y} />
        <Column images={[images[3], images[4], images[5]]} y={y2} />
        <Column images={[images[6], images[7], images[8]]} y={y3} />
        <Column images={[images[9], images[10], images[11]]} y={y4} />
      </div>

      <div className={styles.spacer}></div>
    </main>
  );
}

const Column = ({ images, y }) => {
  return (
    <motion.div
      className={styles.column}
      style={{ y }}
    >
      {images.map((src, i) => (
        <div key={i} className={styles.imageContainer}>
          <img src={`/images/${src}`} alt="photos" fill />
        </div>
      ))}
    </motion.div>
  );
}

export default Paralax;
